import { render, staticRenderFns } from "./CustomerGeneral.vue?vue&type=template&id=07929b0c"
import script from "./CustomerGeneral.vue?vue&type=script&lang=js"
export * from "./CustomerGeneral.vue?vue&type=script&lang=js"
import style0 from "./CustomerGeneral.vue?vue&type=style&index=0&id=07929b0c&prod&lang=css"
import style1 from "./CustomerGeneral.vue?vue&type=style&index=1&id=07929b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports